import * as React from "react"
import type { SVGProps } from "react"
const SvgShare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M17 22.71a3 3 0 0 1-2.12-.87A3 3 0 0 1 14 19.7q0-.15.08-.7l-7.03-4.1a3 3 0 0 1-2.05.8 3 3 0 0 1-2.13-.87A3 3 0 0 1 2 12.7q0-1.25.88-2.12A3 3 0 0 1 5 9.7a3 3 0 0 1 2.05.8l7.03-4.1-.07-.33L14 5.7q0-1.25.88-2.12A3 3 0 0 1 17 2.7q1.24 0 2.13.88.87.88.87 2.12 0 1.26-.87 2.13A3 3 0 0 1 17 8.7a3 3 0 0 1-2.05-.8L7.93 12l.06.34a5 5 0 0 1-.07 1.06l7.03 4.1a3 3 0 0 1 2.05-.8q1.24 0 2.13.88.87.88.87 2.12 0 1.26-.87 2.13a3 3 0 0 1-2.13.87" />
  </svg>
)
export default SvgShare
